import * as React from 'react';
import { inquiryHeader, InquirySelectBody } from './InquiryListField';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import '../css/modal_layout.css';
import * as Header from '../constants/Header';
// import { Dialog, Button, Form, Input, DatePicker, Radio, Select, Message  } from 'element-react';
// import { Patient, Hospital } from '@src/interfaces';
import Back from './common/Back';

interface InquiryListProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

class InquiryList extends React.Component<InquiryListProps> {

  constructor(props: any) {
    super(props);
  }

  componentWillMount() {
    document.title = '問い合わせ一覧画面';

    this.props.headerActions.setPage(Header.INQUIRY_LIST);

    // Action
    this.props.moffAPIActions.getAllInquiries();
  }

  render() {
    return (
      <div>
        <Back />
        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {inquiryHeader}
              </tr>
            </thead>
            <tbody>
              <InquirySelectBody
                inquiries={this.props.moffAPI.inquiries}
                moffAPI={this.props.moffAPI}
                moffAPIActions={this.props.moffAPIActions}
              />
            </tbody>
          </table>
        </div>
        <style type="text/css">
          {'#wrapper .contentIn { padding-top: 50px;text-align: left; }'}
          {'.btnStyle02 { margin-bottom: 16px;text-align: left;max-width: 100%; }'}
          {'td a { color: #23527c;}'}
          {'td a:hover { text-decoration: underline;opacity: 0.8;}'}
          {'td a:before { content:"- "}'}
        </style>
      </div>
    );
  }
}

export default InquiryList;



// WEBPACK FOOTER //
// ./src/components/InquiryList.tsx